import { SectionHeader } from "./section-header";
import { Button } from "./button";
import { navigate } from "../../lib/router";
import { ChevronLeft } from "lucide-react";
import { useLanguage } from "../../hooks/useLanguage";

type PageHeaderProps = {
  label: string;
  title: string;
  onBack?: () => void;
  backTo?: string;
  actions?: React.ReactNode;
  showUnsavedChanges?: boolean;
  backIcon?: React.ReactNode;
};

export function PageHeader({
  label,
  title,
  onBack,
  backTo = "/app",
  actions,
  showUnsavedChanges = false
}: PageHeaderProps) {
  const { t } = useLanguage();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(backTo);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Button
          variant="icon"
          onClick={handleBack}
          icon={<ChevronLeft className="w-6 h-6" />}
        />
        <div className="flex items-center gap-2">
          <SectionHeader label={label} title={title} />
          {showUnsavedChanges && (
            <div className="flex items-center gap-1 text-amber-600 text-xs font-medium">
              <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></div>
              {t.common.unsaved}
            </div>
          )}
        </div>
      </div>

      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
